import { Box } from '@mui/material'
import React from 'react'
import { ToastContainer } from 'react-toastify'
import FishOrder from './FishOrder'
import FshOrderBreadCrumbs from './ProcessComponents/FshOrderBreadCrumbs'

export default function PendingFishOrder() {
    return (
        <div className="container Order">
            <div 
            // className="my-2"
            >
                <FshOrderBreadCrumbs />
            </div>
            <div>
                <ToastContainer />
            </div>
            <Box sx={{ flexGrow: 1, height: '75vh', overflow: 'auto', paddingRight: '10px' }}>
                <FishOrder xStatus='Enter' key="PendingFishOrder" />
            </Box>
        </div>
    )
}
